export default "/assets/font_family_montserrat-02de3292a51d392e4b6eb0a27ad71cf5cc53bf456ad2edf8019f51ad5d3bb42c.svg";